import Breadcrumb from '../components/sections/Breadcrumb';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Breadcrumb title="Privacy Policy" subtitle="PRIVACY POLICY" />

      <section 
        className="py-16 md:py-20 bg-white"
        style={{
          padding: '4rem 0',
          backgroundColor: '#ffffff'
        }}
      >
        <div 
          className="container mx-auto px-6 md:px-8 lg:px-12" 
          style={{ 
            maxWidth: '1200px',
            margin: '0 auto',
            padding: '0 1.5rem'
          }}
        >
          <div 
            className="max-w-4xl mx-auto"
            style={{
              maxWidth: '56rem',
              margin: '0 auto'
            }}
          >
            {/* Header Section */}
            <div 
              className="mb-12 text-center"
              style={{
                marginBottom: '3rem',
                textAlign: 'center'
              }}
            >
              <div 
                className="inline-flex items-center px-4 py-2 rounded-full mb-6"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  padding: '0.5rem 1rem',
                  borderRadius: '9999px',
                  backgroundColor: '#FFF7ED',
                  border: '2px solid #ffba17',
                  marginBottom: '1.5rem'
                }}
              >
                <i 
                  className="fa-solid fa-shield-halved mr-2"
                  style={{
                    color: '#ffba17',
                    marginRight: '0.5rem',
                    fontSize: '1.125rem'
                  }}
                ></i>
                <span 
                  className="text-sm font-semibold uppercase tracking-wider"
                  style={{
                    fontSize: '0.875rem',
                    fontWeight: '600',
                    letterSpacing: '0.05em',
                    textTransform: 'uppercase',
                    color: '#ffba17'
                  }}
                >
                  Your Privacy Matters
                </span>
              </div>
              <p 
                className="text-gray-500 text-sm"
                style={{
                  color: '#6B7280',
                  fontSize: '0.875rem',
                  marginTop: '1rem'
                }}
              >
                Last updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </div>

            {/* Content Sections */}
            <div className="space-y-10">
              {/* Section 1 */}
              <div 
                className="bg-white border-l-4 pl-6 py-4"
                style={{
                  backgroundColor: 'white',
                  borderLeft: '4px solid #ffba17',
                  paddingLeft: '1.5rem',
                  paddingTop: '1rem',
                  paddingBottom: '1rem'
                }}
              >
                <h2 
                  className="text-2xl md:text-3xl font-bold mb-4"
                  style={{
                    fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                    fontWeight: '700',
                    color: '#0f1b3c',
                    marginBottom: '1rem'
                  }}
                >
                  <span className="mr-3" style={{ color: '#ffba17', marginRight: '0.75rem' }}>1.</span>
                  Introduction
                </h2>
                <p 
                  className="text-gray-600 leading-relaxed"
                  style={{
                    color: '#4B5563',
                    lineHeight: '1.8',
                    fontSize: '1.0625rem'
                  }}
                >
                  Tanzania Digital Awards ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website or participate in our awards program.
                </p>
              </div>

              {/* Section 2 */}
              <div 
                className="bg-gray-50 rounded-xl p-6 md:p-8"
                style={{
                  backgroundColor: '#F9FAFB',
                  borderRadius: '0.75rem',
                  padding: '2rem'
                }}
              >
                <h2 
                  className="text-2xl md:text-3xl font-bold mb-4"
                  style={{
                    fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                    fontWeight: '700',
                    color: '#0f1b3c',
                    marginBottom: '1rem'
                  }}
                >
                  <span className="mr-3" style={{ color: '#ffba17', marginRight: '0.75rem' }}>2.</span>
                  Information We Collect
                </h2>
                <p 
                  className="text-gray-600 mb-4 leading-relaxed"
                  style={{
                    color: '#4B5563',
                    marginBottom: '1rem',
                    lineHeight: '1.8',
                    fontSize: '1.0625rem'
                  }}
                >
                  We collect information that you provide directly to us, including:
                </p>
                <ul className="space-y-3">
                  {[
                    'Name and contact information (email address, phone number)',
                    'Organization details',
                    'Nomination and voting information',
                    'Profile information and photos',
                    'Communication preferences'
                  ].map((item, index) => (
                    <li 
                      key={index} 
                      className="flex items-start"
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start'
                      }}
                    >
                      <i 
                        className="fa-solid fa-check-circle mt-1 mr-3"
                        style={{
                          color: '#ffba17',
                          marginTop: '0.25rem',
                          marginRight: '0.75rem',
                          flexShrink: '0'
                        }}
                      ></i>
                      <span 
                        className="text-gray-600 leading-relaxed"
                        style={{
                          color: '#4B5563',
                          lineHeight: '1.75',
                          fontSize: '1rem'
                        }}
                      >
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Section 3 */}
              <div 
                className="bg-white border-l-4 pl-6 py-4"
                style={{
                  backgroundColor: 'white',
                  borderLeft: '4px solid #ffba17',
                  paddingLeft: '1.5rem',
                  paddingTop: '1rem',
                  paddingBottom: '1rem'
                }}
              >
                <h2 
                  className="text-2xl md:text-3xl font-bold mb-4"
                  style={{
                    fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                    fontWeight: '700',
                    color: '#0f1b3c',
                    marginBottom: '1rem'
                  }}
                >
                  <span className="mr-3" style={{ color: '#ffba17', marginRight: '0.75rem' }}>3.</span>
                  How We Use Your Information
                </h2>
                <p 
                  className="text-gray-600 mb-4 leading-relaxed"
                  style={{
                    color: '#4B5563',
                    marginBottom: '1rem',
                    lineHeight: '1.8',
                    fontSize: '1.0625rem'
                  }}
                >
                  We use the information we collect to:
                </p>
                <ul className="space-y-3">
                  {[
                    'Process nominations and manage the awards program',
                    'Communicate with you about the awards and related events',
                    'Send you newsletters and marketing communications (with your consent)',
                    'Improve our website and services',
                    'Comply with legal obligations'
                  ].map((item, index) => (
                    <li 
                      key={index} 
                      className="flex items-start"
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start'
                      }}
                    >
                      <i 
                        className="fa-solid fa-check-circle mt-1 mr-3"
                        style={{
                          color: '#ffba17',
                          marginTop: '0.25rem',
                          marginRight: '0.75rem',
                          flexShrink: '0'
                        }}
                      ></i>
                      <span 
                        className="text-gray-600 leading-relaxed"
                        style={{
                          color: '#4B5563',
                          lineHeight: '1.75',
                          fontSize: '1rem'
                        }}
                      >
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Section 4 */}
              <div 
                className="bg-gray-50 rounded-xl p-6 md:p-8"
                style={{
                  backgroundColor: '#F9FAFB',
                  borderRadius: '0.75rem',
                  padding: '2rem'
                }}
              >
                <h2 
                  className="text-2xl md:text-3xl font-bold mb-4"
                  style={{
                    fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                    fontWeight: '700',
                    color: '#0f1b3c',
                    marginBottom: '1rem'
                  }}
                >
                  <span className="mr-3" style={{ color: '#ffba17', marginRight: '0.75rem' }}>4.</span>
                  Information Sharing
                </h2>
                <p 
                  className="text-gray-600 mb-4 leading-relaxed"
                  style={{
                    color: '#4B5563',
                    marginBottom: '1rem',
                    lineHeight: '1.8',
                    fontSize: '1.0625rem'
                  }}
                >
                  We do not sell your personal information. We may share your information with:
                </p>
                <ul className="space-y-3">
                  {[
                    'Service providers who assist in operating our website and awards program',
                    'Judges and evaluation panel members (limited to nomination-related information)',
                    'The public (for winners\' information and publicity)',
                    'Legal authorities when required by law'
                  ].map((item, index) => (
                    <li 
                      key={index} 
                      className="flex items-start"
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start'
                      }}
                    >
                      <i 
                        className="fa-solid fa-check-circle mt-1 mr-3"
                        style={{
                          color: '#ffba17',
                          marginTop: '0.25rem',
                          marginRight: '0.75rem',
                          flexShrink: '0'
                        }}
                      ></i>
                      <span 
                        className="text-gray-600 leading-relaxed"
                        style={{
                          color: '#4B5563',
                          lineHeight: '1.75',
                          fontSize: '1rem'
                        }}
                      >
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Section 5 */}
              <div 
                className="bg-white border-l-4 pl-6 py-4"
                style={{
                  backgroundColor: 'white',
                  borderLeft: '4px solid #ffba17',
                  paddingLeft: '1.5rem',
                  paddingTop: '1rem',
                  paddingBottom: '1rem'
                }}
              >
                <h2 
                  className="text-2xl md:text-3xl font-bold mb-4"
                  style={{
                    fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                    fontWeight: '700',
                    color: '#0f1b3c',
                    marginBottom: '1rem'
                  }}
                >
                  <span className="mr-3" style={{ color: '#ffba17', marginRight: '0.75rem' }}>5.</span>
                  Data Security
                </h2>
                <p 
                  className="text-gray-600 leading-relaxed"
                  style={{
                    color: '#4B5563',
                    lineHeight: '1.8',
                    fontSize: '1.0625rem'
                  }}
                >
                  We implement appropriate technical and organizational measures to protect your personal information. However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security.
                </p>
              </div>

              {/* Section 6 */}
              <div 
                className="bg-gray-50 rounded-xl p-6 md:p-8"
                style={{
                  backgroundColor: '#F9FAFB',
                  borderRadius: '0.75rem',
                  padding: '2rem'
                }}
              >
                <h2 
                  className="text-2xl md:text-3xl font-bold mb-4"
                  style={{
                    fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                    fontWeight: '700',
                    color: '#0f1b3c',
                    marginBottom: '1rem'
                  }}
                >
                  <span className="mr-3" style={{ color: '#ffba17', marginRight: '0.75rem' }}>6.</span>
                  Your Rights
                </h2>
                <p 
                  className="text-gray-600 mb-4 leading-relaxed"
                  style={{
                    color: '#4B5563',
                    marginBottom: '1rem',
                    lineHeight: '1.8',
                    fontSize: '1.0625rem'
                  }}
                >
                  You have the right to:
                </p>
                <ul className="space-y-3">
                  {[
                    'Access your personal information',
                    'Correct inaccurate information',
                    'Request deletion of your information',
                    'Opt-out of marketing communications',
                    'Object to processing of your information'
                  ].map((item, index) => (
                    <li 
                      key={index} 
                      className="flex items-start"
                      style={{
                        display: 'flex',
                        alignItems: 'flex-start'
                      }}
                    >
                      <i 
                        className="fa-solid fa-check-circle mt-1 mr-3"
                        style={{
                          color: '#ffba17',
                          marginTop: '0.25rem',
                          marginRight: '0.75rem',
                          flexShrink: '0'
                        }}
                      ></i>
                      <span 
                        className="text-gray-600 leading-relaxed"
                        style={{
                          color: '#4B5563',
                          lineHeight: '1.75',
                          fontSize: '1rem'
                        }}
                      >
                        {item}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* Section 7 */}
              <div 
                className="bg-white border-l-4 pl-6 py-4"
                style={{
                  backgroundColor: 'white',
                  borderLeft: '4px solid #ffba17',
                  paddingLeft: '1.5rem',
                  paddingTop: '1rem',
                  paddingBottom: '1rem'
                }}
              >
                <h2 
                  className="text-2xl md:text-3xl font-bold mb-4"
                  style={{
                    fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                    fontWeight: '700',
                    color: '#0f1b3c',
                    marginBottom: '1rem'
                  }}
                >
                  <span className="mr-3" style={{ color: '#ffba17', marginRight: '0.75rem' }}>7.</span>
                  Cookies
                </h2>
                <p 
                  className="text-gray-600 leading-relaxed"
                  style={{
                    color: '#4B5563',
                    lineHeight: '1.8',
                    fontSize: '1.0625rem'
                  }}
                >
                  We use cookies and similar tracking technologies to enhance your experience on our website. You can control cookies through your browser settings.
                </p>
              </div>

              {/* Contact Section */}
              <div 
                className="rounded-xl p-8 md:p-10"
                style={{
                  background: 'linear-gradient(135deg, #0f1b3c 0%, #1a2d5c 100%)',
                  borderRadius: '0.75rem',
                  padding: '2.5rem'
                }}
              >
                <h2 
                  className="text-2xl md:text-3xl font-bold mb-4 text-white"
                  style={{
                    fontSize: 'clamp(1.5rem, 3vw, 1.875rem)',
                    fontWeight: '700',
                    color: 'white',
                    marginBottom: '1rem'
                  }}
                >
                  <i 
                    className="fa-solid fa-envelope mr-3"
                    style={{
                      color: '#ffba17',
                      marginRight: '0.75rem'
                    }}
                  ></i>
                  Contact Us
                </h2>
                <p 
                  className="text-gray-300 mb-6 leading-relaxed"
                  style={{
                    color: '#D1D5DB',
                    marginBottom: '1.5rem',
                    lineHeight: '1.8',
                    fontSize: '1.0625rem'
                  }}
                >
                  If you have any questions about this Privacy Policy, please contact us:
                </p>
                <div className="space-y-4">
                  <div 
                    className="flex items-start"
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start'
                    }}
                  >
                    <i 
                      className="fa-solid fa-envelope mt-1 mr-4"
                      style={{
                        color: '#ffba17',
                        marginTop: '0.25rem',
                        marginRight: '1rem',
                        flexShrink: '0'
                      }}
                    ></i>
                    <div>
                      <p 
                        className="text-sm text-gray-400 mb-1"
                        style={{
                          fontSize: '0.875rem',
                          color: '#9CA3AF',
                          marginBottom: '0.25rem'
                        }}
                      >
                        Email
                      </p>
                      <a 
                        href="mailto:info@digitalawards.co.tz"
                        className="text-white hover:text-gold transition-colors"
                        style={{
                          color: 'white',
                          textDecoration: 'none',
                          fontSize: '1.0625rem',
                          cursor: 'pointer'
                        }}
                      >
                        info@digitalawards.co.tz
                      </a>
                    </div>
                  </div>
                  <div 
                    className="flex items-start"
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start'
                    }}
                  >
                    <i 
                      className="fa-solid fa-phone mt-1 mr-4"
                      style={{
                        color: '#ffba17',
                        marginTop: '0.25rem',
                        marginRight: '1rem',
                        flexShrink: '0'
                      }}
                    ></i>
                    <div>
                      <p 
                        className="text-sm text-gray-400 mb-1"
                        style={{
                          fontSize: '0.875rem',
                          color: '#9CA3AF',
                          marginBottom: '0.25rem'
                        }}
                      >
                        Phone
                      </p>
                      <p 
                        className="text-white"
                        style={{
                          color: 'white',
                          fontSize: '1.0625rem'
                        }}
                      >
                        +255 737 957082 / +255 719 579733
                      </p>
                    </div>
                  </div>
                  <div 
                    className="flex items-start"
                    style={{
                      display: 'flex',
                      alignItems: 'flex-start'
                    }}
                  >
                    <i 
                      className="fa-solid fa-map-marker-alt mt-1 mr-4"
                      style={{
                        color: '#ffba17',
                        marginTop: '0.25rem',
                        marginRight: '1rem',
                        flexShrink: '0'
                      }}
                    ></i>
                    <div>
                      <p 
                        className="text-sm text-gray-400 mb-1"
                        style={{
                          fontSize: '0.875rem',
                          color: '#9CA3AF',
                          marginBottom: '0.25rem'
                        }}
                      >
                        Address
                      </p>
                      <p 
                        className="text-white"
                        style={{
                          color: 'white',
                          fontSize: '1.0625rem',
                          lineHeight: '1.75'
                        }}
                      >
                        8th Floor, Victoria House, Mikocheni,<br />Dar es Salaam, Tanzania
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;

